import { useRef, useState, useEffect, RefObject } from 'react'

import useIsomorphicLayoutEffect from '../useIsomorphicLayoutEffect'

export interface Dimensions {
  width: number
  height: number
}

export default function useDimensions<T extends HTMLElement>(): [RefObject<T>, Dimensions] {
  const ref = useRef<T>(null)
  const [dimensions, setDimensions] = useState<Dimensions>({
    width: 0,
    height: 0,
  })

  function setDimensionFromRef(): void {
    if (ref.current) {
      setDimensions({
        width: ref.current.clientWidth,
        height: ref.current.clientHeight,
      })
    }
  }

  // Ensure dimensions set synchronously on initial load
  useIsomorphicLayoutEffect(() => {
    setDimensionFromRef()
  }, [])

  // Ensure dimensions are updated on window resize
  useEffect(() => {
    window.addEventListener('resize', setDimensionFromRef)
    return (): void => window.removeEventListener('resize', setDimensionFromRef)
  }, [])

  return [ref, dimensions]
}
